import React, { useState } from "react"
import * as S from "./Information.Style"
import { ReactComponent as InformationIcon } from "../../../../assets/images/habitacional/information-icon.svg"

const Information = ({ text }) => {
    const [tooltipVisible, setTooltipVisible] = useState(false);

    return (
            <div style={{ display: "inline-flex", gap:"10px" }}>
                <InformationIcon onMouseOver={() => setTooltipVisible(true)} onMouseOut={() => setTooltipVisible(false)} />
                <S.ContentToolTip visible={tooltipVisible} onMouseOver={() => setTooltipVisible(true)} onMouseOut={() => setTooltipVisible(false)}>
                    <S.TextToolTip>
                        {text}
                    </S.TextToolTip>
                </S.ContentToolTip>
            </div>
    )
}

export default Information